import {defineStore} from "pinia";
import axios from "axios";
import {useTableStore} from "@/stores/table";

function groupTagsByCategory(arr) {
    return arr.reduce((acc, { id, category, name }) => {
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push({ id, name, category, value: false });
        return acc;
    }, {});
}


export const useSources = defineStore({
    id: "sourcesStore",
    state: () => ({
        pageNumber: 1,
        pageLimit: 10,
        sourcesSearchField: "",
        activeSortingColumn: null,
        activeSortingOrder: "asc",
        sources: [],
    }),
    actions: {

        async getSources(filterTagOptions = null, filterOptions = null, pageLimit = null)
        {
            const tableStore = useTableStore();

            try {
                const params = new URLSearchParams({
                    page: this.pageNumber,
                    limit: pageLimit || this.pageLimit,
                });

                if (this.sourcesSearchField) {
                    params.set("query", this.sourcesSearchField);
                }
                if (this.activeSortingColumn != null) {
                    params.set("sort_by", this.activeSortingColumn);
                }
                if (this.activeSortingOrder != null) {
                    params.set("sort_direction", this.activeSortingOrder);
                }

                // Фильтры по тегам
                if (filterTagOptions && filterTagOptions.selected) {
                    filterTagOptions.selected.forEach((tag) => {
                        params.append("tag_ids", tag.id);
                    });
                }

                // Остальные фильтры
                if (filterOptions) {
                    filterOptions.forEach((section) => {
                        if (Array.isArray(section.options)) {
                            section.options.forEach((opt) => {
                                if (opt.value === true) {
                                    params.append(
                                        section.id,
                                        String(opt.id).toLowerCase()
                                    );
                                }
                            });
                        }
                    });
                }

                const { data } = await axios.get(`/sources/?${params.toString()}`);
                tableStore.filteredListData = data.results
                return data;
            } catch (e) {
                console.log(e);
            }
        },

        async getFilterFields(type, query, count = 20) {
            try {
                const { data } = await axios.get(`/sources/fields?type=${type}&query=${query}&count=${count}`);
                return data;
            } catch (error) {
                console.log(error);
                return [];
            }
        },
        async getTags(query = "", page = 1, limit = 1000, category = null, group = true) {
            try {
                const params = { page, query, limit };
                if (category !== null) {
                    params.category = category;
                }
                const { data } = await axios.get("/tags/", { params });
                if (group) {
                    return groupTagsByCategory(data.results);
                } else {
                    return data.results;
                }

            } catch (error) {
                console.log(error);
                return [];
            }
        },

        async getTagsCategories (query = "", page = 1, limit = 100) {
            try {
                const { data } = await axios.get(`/tags/categories?page=${page}&query=${query}&limit=${limit}`);
                return data.results;
            } catch (error) {
                console.log(error);
                return [];
            }
        },

        async getTagByCategory(categoryName) {
            return await this.getTags(undefined, undefined, undefined, categoryName, false);
        },

        async createSource(payload) {
          try {
                await axios.post(`/sources/`, payload);
              window.storeLK.createNotify("Источник добавлен", "success");
          }  catch (e) {
              console.log(e);
              window.storeLK.createNotify("Ошибка создания источника", "success");
              return false;
          }
        },

        async deleteSource(sourceId) {
            try {
                await axios.delete(`/sources/${sourceId}`);
                window.storeLK.createNotify(`Источник ${sourceId} удален`, "success");
            }  catch (e) {
                console.log(e);
                window.storeLK.createNotify(`Ошибка удаления источника ${sourceId}`, "success");
                return false;
            }
        },

        async updateSource(source_id, payload) {
            const tableStore = useTableStore();

            try {
                await axios.patch(`/sources/${source_id}`,
                    payload, { headers: { "Content-Type": "application/merge-patch+json"}});
                await this.getSources();
                tableStore.createTagModalIsActive = false;
                window.storeLK.createNotify("Источник обновлен", "success");
                return true;
            } catch (e) {
                console.log(e);
                window.storeLK.createNotify("Ошибка обновления источника", "success");
                return false;
            }
        },

        async updateSourceArchive(source_id, type) {
          await this.updateSource(source_id, {is_archived: type});
        },

        async updateSourceStatus(source_id, status) {
          await this.updateSource(source_id, {is_enabled: status});
        },

        async updateSourceTag(source_id, tag_ids) {
            await this.updateSource(source_id, {tag_ids: tag_ids});
        },
    }
});
